import React from 'react';
import './PublicFooter.css';

const PublicFooter = () => {
  return (
    <footer className="public-footer">
      <div className="footer-content">
        <div className="footer-main">
          <div className="footer-brand">
            <div className="footer-logo-row">
              <img
                src="https://securelayer7.net/assets/image/recent/sl7-logo.svg"
                alt="SecureLayer7"
                className="footer-logo"
                onError={(e) => { e.target.style.display = 'none'; }}
              />
              <span className="footer-brand-name">SecureLayer7</span>
            </div>
            <p className="footer-brand-desc">
              Research-led penetration testing, source code review, and autonomous pentester software. Trusted by 1,000+ clients across 30+ countries.
            </p>
            <div className="footer-badges">
              <span className="footer-badge">CREST Accredited</span>
              <span className="footer-badge">10+ Years</span>
              <span className="footer-badge">40K+ Vulns Found</span>
            </div>
          </div>

          <div className="footer-links">
            <div className="footer-col">
              <h4>Company</h4>
              <a href="https://securelayer7.net/about-us" target="_blank" rel="noopener noreferrer">About Us</a>
              <a href="https://securelayer7.net/our-services" target="_blank" rel="noopener noreferrer">Services</a>
              <a href="https://securelayer7.net/products/api-security-scanner" target="_blank" rel="noopener noreferrer">BugDazz Platform</a>
              <a href="https://securelayer7.net/start-now" target="_blank" rel="noopener noreferrer">Contact</a>
            </div>
            <div className="footer-col">
              <h4>Services</h4>
              <a href="https://securelayer7.net/services/application-security-testing" target="_blank" rel="noopener noreferrer">Application Security</a>
              <a href="https://securelayer7.net/services/cloud-penetration-testing" target="_blank" rel="noopener noreferrer">Cloud Security</a>
              <a href="https://securelayer7.net/services/red-team-assessment" target="_blank" rel="noopener noreferrer">Red Team Assessment</a>
              <a href="https://securelayer7.net/services/ai-security-assessment" target="_blank" rel="noopener noreferrer">AI Security</a>
            </div>
            <div className="footer-col">
              <h4>Research</h4>
              <a href="https://blog.securelayer7.net" target="_blank" rel="noopener noreferrer">Security Blog</a>
              <a href="https://blog.securelayer7.net/cve-2026-25049/" target="_blank" rel="noopener noreferrer">CVE Research</a>
              <a href="https://blog.securelayer7.net/owasp-top-10-security-risks/" target="_blank" rel="noopener noreferrer">OWASP Top 10</a>
              <a href="https://blog.securelayer7.net/category/working-with-securelayer7/" target="_blank" rel="noopener noreferrer">Life at SL7</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} SecureLayer7. All rights reserved.</p>
          <div className="footer-social">
            <a href="https://www.linkedin.com/company/securelayer7/" target="_blank" rel="noopener noreferrer" className="footer-social-link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
              <span>LinkedIn</span>
            </a>
            <a href="https://x.com/securelayer7" target="_blank" rel="noopener noreferrer" className="footer-social-link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
              <span>X (Twitter)</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
